import styled from 'styled-components';
import { mobileFilterContainer } from 'components/Page/SuccessStories/Splash/Filter/Dropdowns/styles';

const Container = styled.div`
  .title {
    padding-bottom: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid #cccccc;
    color: var(--neutral-7);
  }
  .list-item {
    padding-bottom: 15px;
    &:hover {
      cursor: pointer;
    }
  }
  .selected {
    color: var(--blue-5);
  }
  .toolbox-details-filters-mobile--container {
    z-index: 1000;
    background: var(--white-color);
    height: 70px;
    position: fixed !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px 30px;
    box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;
  }
  .toolbox-details-filters-mobile--clear-filters {
    display: block;
    &:hover {
      cursor: pointer;
    }
  }
  .toolbox-details-filters-mobile--close-icon {
    width: 20px;
    height: 20px;
  }
  .remove-filter-icon {
    width: 18px;
    height: 18px;
    margin-top: -3px;
    margin-left: 7px;
  }
  .toolbox-details-filters-mobile--apply-filter {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    left: 0;
    background: white;
    justify-content: center;
    padding: 10px 0;
    border-top: 1px solid #ccc !important;
  }
  @media (min-width: 577px) {
    display: none;
  }
  @media (max-width: 576px) {
    ${mobileFilterContainer}
    .title {
      padding-bottom: 10px;
    }
  }
`;

export { Container };
